import { useQuery } from 'react-query';
import { LicenseDataType } from './useGetCurrentLicenseData';
import axios from 'axios';
import { commonHeaders } from '../../constants/HeadersAPI';
import { LicenseAPI } from '../../constants/API';

export const useGetAllLicenses = () => {
  const { data: allLicenses, isFetching: isAllLicensesFetching } = useQuery({
    queryKey: ['getAllLicenses'],
    queryFn: async () => {
      const { data } = await axios.get<LicenseDataType[]>(LicenseAPI.allLicenses, commonHeaders());

      return data;
    }
  });
  return {
    allLicenses,
    isAllLicensesFetching
  };
};
